module.exports = __webpack_public_path__ + "img/ep-Q-dosis.d9077854.jpg";